var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.formRules,
            "label-width": "auto",
          },
        },
        _vm._l(_vm.formConfig, function (item, key, index) {
          return _c(
            "el-form-item",
            { key: key, attrs: { label: item.label, prop: item.key } },
            [
              item.type == "radio"
                ? _c(
                    "el-radio-group",
                    {
                      staticClass: "vertical",
                      model: {
                        value: _vm.form[item.key],
                        callback: function ($$v) {
                          _vm.$set(_vm.form, item.key, $$v)
                        },
                        expression: "form[item.key]",
                      },
                    },
                    _vm._l(item.options, function (itemOption, index) {
                      return _c(
                        "el-radio",
                        { key: index, attrs: { label: itemOption.label } },
                        [_vm._v(_vm._s(itemOption.value))]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              item.type == "date"
                ? _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      size: "small",
                      placeholder: item.placeholder,
                      type: "date",
                      format: item.format,
                      "value-format": item.format,
                    },
                    model: {
                      value: _vm.form[item.key],
                      callback: function ($$v) {
                        _vm.$set(_vm.form, item.key, $$v)
                      },
                      expression: "form[item.key]",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              item.type == "input"
                ? _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: item.placeholder,
                      maxlength: item.maxlength,
                      size: "small",
                      disabled: item.disabled,
                    },
                    model: {
                      value: _vm.form[item.key],
                      callback: function ($$v) {
                        _vm.$set(_vm.form, item.key, $$v)
                      },
                      expression: "form[item.key]",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              item.type == "inputEn"
                ? _c(
                    "el-input",
                    {
                      attrs: {
                        disabled: _vm.fromData.type == "edit" ? true : false,
                        placeholder: item.placeholder,
                        size: "small",
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.refreshFn(item.refresh, item.key)
                        },
                      },
                      model: {
                        value: _vm.form[item.key],
                        callback: function ($$v) {
                          _vm.$set(_vm.form, item.key, $$v)
                        },
                        expression: "form[item.key]",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "refresh",
                          attrs: {
                            slot: "suffix",
                            type: "primary",
                            disabled:
                              _vm.fromData.type == "edit" ? true : false,
                            size: "small",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.refreshFn(item.refresh, item.key)
                            },
                          },
                          slot: "suffix",
                        },
                        [_vm._v("\n          刷新生成")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              item.type == "textarea"
                ? _c("el-input", {
                    staticClass: "textarea",
                    attrs: {
                      type: "textarea",
                      placeholder: "请输入内容",
                      maxlength: item.maxlength,
                      placeholder: item.placeholder,
                      size: "small",
                    },
                    model: {
                      value: _vm.form[item.key],
                      callback: function ($$v) {
                        _vm.$set(_vm.form, item.key, $$v)
                      },
                      expression: "form[item.key]",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              item.type === "richText"
                ? _c("ueditor-from", {
                    ref: "ueditorFrom",
                    refInFor: true,
                    attrs: {
                      border: true,
                      content: _vm.form[item.key],
                      height: "400px",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.ueditorEdit($event, item)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              item.type == "password"
                ? _c("el-input", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "password",
                      "prefix-icon": "el-icon-lock",
                      placeholder: item.placeholder,
                      "show-password": "",
                      size: "small",
                    },
                    model: {
                      value: _vm.form[item.key],
                      callback: function ($$v) {
                        _vm.$set(_vm.form, item.key, $$v)
                      },
                      expression: "form[item.key]",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              item.type == "number"
                ? _c(
                    "div",
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { size: "small", min: item.min, max: item.max },
                        model: {
                          value: _vm.form[item.key],
                          callback: function ($$v) {
                            _vm.$set(_vm.form, item.key, $$v)
                          },
                          expression: "form[item.key]",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "tips" }, [
                        _vm._v(_vm._s(item.tips)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              item.type == "inputNumber"
                ? _c("el-input", {
                    attrs: {
                      type: "number",
                      size: "small",
                      placeholder: item.placeholder,
                    },
                    model: {
                      value: _vm.form[item.key],
                      callback: function ($$v) {
                        _vm.$set(_vm.form, item.key, $$v)
                      },
                      expression: "form[item.key]",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              item.type == "switch"
                ? _c("el-switch", {
                    attrs: {
                      size: "small",
                      "active-value": item.activeValue,
                      "inactive-value": item.inactiveValue,
                      "active-text": item.activeText,
                      "inactive-text": item.inactiveText,
                    },
                    model: {
                      value: _vm.form[item.key],
                      callback: function ($$v) {
                        _vm.$set(_vm.form, item.key, $$v)
                      },
                      expression: "form[item.key]",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              item.type == "month"
                ? _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "month",
                      size: "small",
                      "picker-options": _vm.pickerOptions,
                      placeholder: "选择月",
                    },
                    model: {
                      value: _vm.form[item.key],
                      callback: function ($$v) {
                        _vm.$set(_vm.form, item.key, $$v)
                      },
                      expression: "form[item.key]",
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              item.type == "select"
                ? _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: item.disabled,
                            filterable: "",
                            size: "small",
                            placeholder: item.placeholder,
                          },
                          on: { change: _vm.selectChange },
                          model: {
                            value: _vm.form[item.key],
                            callback: function ($$v) {
                              _vm.$set(_vm.form, item.key, $$v)
                            },
                            expression: "form[item.key]",
                          },
                        },
                        _vm._l(item.options, function (v, index) {
                          return _c("el-option", {
                            key: v.id,
                            attrs: {
                              label: v.label || v.name || v.table_name,
                              value: v.id || v.value,
                            },
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      item.sign == "dict"
                        ? _c(
                            "div",
                            { staticClass: "fang", on: { click: _vm.goDict } },
                            [
                              _c("span", {
                                staticClass:
                                  "iconfont iconxitong-xitongshezhi-cebian",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              item.type == "user_id"
                ? _c("select-member", {
                    staticStyle: { width: "100%" },
                    attrs: { onlyOne: item.only_one },
                    on: {
                      getSelectList: function ($event) {
                        return _vm.getSelectList($event, item)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              item.type == "input_select"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "el-input__inner select plan-footer-on flex-between h32",
                      on: {
                        click: function ($event) {
                          return _vm.checkboxDialogOpen()
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "over-text1",
                          on: {
                            click: function ($event) {
                              return _vm.checkboxDialogOpen()
                            },
                          },
                        },
                        _vm._l(_vm.fieldList, function (items, indexs) {
                          return _c(
                            "span",
                            {
                              key: indexs,
                              on: {
                                click: [
                                  function ($event) {
                                    return _vm.checkboxDialogOpen()
                                  },
                                  function ($event) {
                                    $event.stopPropagation()
                                  },
                                ],
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(items.field_name) +
                                  ",\n          "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "el-tag__close el-icon-arrow-down",
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              item.type == "multipleSelect"
                ? _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled: _vm.fromData.type == "edit",
                        multiple: "",
                        size: "small",
                        filterable: "",
                        placeholder: item.placeholder
                          ? item.placeholder
                          : "请选择",
                      },
                      model: {
                        value: _vm.form[item.key],
                        callback: function ($$v) {
                          _vm.$set(_vm.form, item.key, $$v)
                        },
                        expression: "form[item.key]",
                      },
                    },
                    _vm._l(item.options, function (v, index) {
                      return _c("el-option", {
                        key: v.id,
                        attrs: { label: v.name, value: v.id },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              item.type == "cascader"
                ? _c(
                    "div",
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          options: item.options,
                          filterable: "",
                          size: "small",
                          "show-all-levels": false,
                          props: item.props,
                          clearable: "",
                          placeholder: item.placeholder
                            ? item.placeholder
                            : "请选择",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var node = ref.node
                                var data = ref.data
                                return [
                                  _c("span", [_vm._v(_vm._s(data.table_name))]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      " （" + _vm._s(data.table_name_en) + "）"
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.form[item.key],
                          callback: function ($$v) {
                            _vm.$set(_vm.form, item.key, $$v)
                          },
                          expression: "form[item.key]",
                        },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "tips" }, [
                        _vm._v(_vm._s(item.tips)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              item.type == "cascaderNew"
                ? _c(
                    "div",
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          options: item.options,
                          props: { checkStrictly: true },
                          clearable: "",
                          filterable: "",
                        },
                        model: {
                          value: _vm.form[item.key],
                          callback: function ($$v) {
                            _vm.$set(_vm.form, item.key, $$v)
                          },
                          expression: "form[item.key]",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c("checkboxDialog", {
        ref: "checkboxDialog",
        attrs: { type: "field", showCrud: true },
        on: { getData: _vm.getDataFn },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }